import { commonFilter } from './filter';

export default {
  pageName: 'feedsFeedback',
  pageId: '20026',
  pagePath: '/opinion/feedback',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    C_keyword: {
      buttonId: '200260',
    },
    GPT_Get_Btn: {
      buttonId: '2002601',
    },
    GPT_Confirm: {
      buttonId: '2002602',
    },
    ...commonFilter,
  },
};
